import { Injectable } from '@angular/core';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { PromptComponent } from './prompt/prompt.component';
import { DialogComponent } from './dialog/dialog.component';
import { OptionsComponent } from './options/options.component';

@Injectable()
export class DialogService {
  constructor(private matDialog: MatDialog) {}

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'Aceptar',
    btnCancelText: string = 'Cancelar',
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const modal = this.matDialog.open(ConfirmationComponent, {
        width: '500px',

        data: {
          title,
          message,
          btnOkText,
          btnCancelText,
        },
        disableClose: true,
        panelClass: 'redondo-abajo',
      });

      modal.afterClosed().subscribe((response) => {
        if (response) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  public dialog(
    title: string,
    message: string,
    btnCancelText: string = 'Volver',
    width = '500px',
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const modal = this.matDialog.open(DialogComponent, {
        width,
        maxWidth: '90vw',
        data: {
          title,
          message,
          btnCancelText,
        },
        disableClose: true,
        panelClass: 'redondo-abajo',
      });

      modal.afterClosed().subscribe((response) => {
        if (response) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  public prompt(
    title: string,
    message: string,
    inputName: string,
    btnOkText: string = 'Aceptar',
    btnCancelText: string = 'Cancelar',
  ): Promise<string | false> {
    return new Promise((resolve, reject) => {
      const modal = this.matDialog.open(PromptComponent, {
        width: '500px',

        data: {
          title,
          message,
          inputName,
          btnOkText,
          btnCancelText,
        },
        disableClose: true,
        panelClass: 'redondo-abajo',
      });

      modal.afterClosed().subscribe((response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(false);
        }
      });
    });
  }

  public options(
    title: string,
    message: string,
    selectName: string,
    options: string[],
    btnOkText: string = 'Aceptar',
    btnCancelText: string = 'Cancelar',
  ): Promise<string | false> {
    return new Promise((resolve, reject) => {
      const modal = this.matDialog.open(OptionsComponent, {
        width: '500px',

        data: {
          title,
          message,
          selectName,
          btnOkText,
          btnCancelText,
          options,
        },
        disableClose: true,
        panelClass: 'redondo-abajo',
      });

      modal.afterClosed().subscribe((response) => {
        if (response) {
          resolve(response);
        } else {
          resolve(false);
        }
      });
    });
  }
}
